"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const colors_1 = require("../styles/colors");
const Text_1 = require("./Text");
const CloseIcon_1 = require("./Icons/CloseIcon");
const index_1 = require("./index");
const Pill = ({ value, onRemove, style, textColor }) => {
    return (React.createElement("div", { style: Object.assign({ background: colors_1.turquoise, height: '24px', padding: '4px 8px 4px 8px', boxSizing: 'border-box', borderRadius: 12, display: 'inline-flex', alignItems: 'center' }, style) },
        React.createElement(Text_1.default, { size: "x-small", textStyle: Object.assign({ marginRight: onRemove ? 4 : undefined, color: textColor ? textColor : colors_1.white }, index_1.semibold), text: value }),
        onRemove && (React.createElement(CloseIcon_1.default, { height: "16", width: "16", fill: colors_1.foam, style: {
                cursor: 'pointer',
            }, onClick: onRemove }))));
};
exports.default = Pill;
